export const Storages = {
  // FPL Disclaimer
  SHOW_DISCLAIMER_SETTING: 'fpl_disclaimer_visible',
  // Terms and Conditions Disclaimer
  SHOW_TERMS_DISCLAIMER_SETTING: 'terms_disclaimer_visible',
  // Maintenance Disclaimer
  SHOW_MAINTENANCE_DISCLAIMER_SETTING: 'maintenance_disclaimer_visible',
  // Show unpublished plans
  HIDE_UNPUBLISHED_PLANS: 'hide_unpublished',
  // View model
  PORTFOLIOS_VIEW_MODEL: 'portfolios_view_model',
};

export const getFromLocalStorage = (name) => {
  return JSON.parse(localStorage.getItem(name));
};

export const addToLocalStorage = (name, object) => {
  localStorage.setItem(name, JSON.stringify(object));
};

export const removeFromLocalStorage = (name) => {
  localStorage.removeItem(name);
};

export const itemExists = (name) => {
  if (localStorage.getItem(name) === null) {
    return false;
  }
  return true;
};
